// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c2a97164","977":"14e508c7"}[chunkId] + ".chunk.js";
};